
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Svelte and other libraries. It is a great starting point when
 * building robust, powerful web applications using Svelte and Laravel.
 */

require('./libraries');

import Player from "./components/Player.svelte"
import CMS from "./components/CMS.svelte"
import Login from "./components/Login.svelte"

let base = document.querySelector('[data-base]')
let admin = document.querySelector('[data-admin]')
let login = document.querySelector('[data-login]')
let app = false

if(base || admin || login){
  if(admin){
    app = new CMS({
      target: admin
    });
  }else if(base){
    app = new Player({
      target: base
    });
  }else {
    app = new Login({
      target: login
    })
  }

  window.app = app;

}else{
  console.error('No target was defined')
}

export default app;